import React from 'react';
import { Toast } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { Picker } from "antd-mobile";
import { Map } from 'src/jisu-component/map/Map';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';

import './SearchAddress.less';
export default class SearchAddress extends OfficialPage {
  state = {
    nationId: '',
    selectAddressId: '',
    addressList: [],
    afterInitial: false,
    isFromBack: false,
    from: '',
    fromAddAdress: false,
    address_id: '',
    localAddress: '',
    selectProCityDirs: true,
    nationname: '',
    selectRegion: [0, 0, 0],
    selectRegionId: [0, 0, 0],
    latitude: '',
    longitude: '',
    showMap: true,
    show: false,
    regionMap: {},
    regionData: [],
    regionCols: 3,
    regionStr: [],
    searchAddress: [],
    nearbyAddress: []
  }
  subShopId = ''
  timer = 0

  constructor(props) {
    super(props);
    document.title = '搜索地址';
    this.mapRef = React.createRef();
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var that = this,
      from = options.from,
      locateAddress = options.locateAddress || '',
      pid = options.nationId == '1' ? '0' : options.nationId
    var newdata = {}
    if (options.nationId !== undefined && options.nationname !== undefined) {
      newdata.nationId = options.nationId
      newdata.nationname = options.nationname
    }
    if (options.latitude) {
      newdata.latitude = options.latitude
      newdata.longitude = options.longitude
    }
    newdata.from = from
    newdata.locateAddress = locateAddress
    this.setData(newdata)
    this.getArea(pid, data => {
      this.setData({
        regionCols: pid == 0 ? 3 : 2,
        regionMap: data,
        regionData: this.formateRegionData(data)
      })
    })
    this.compindex = options.compindex || ''
    this.locateAddress = locateAddress
    if (from == 'addAddress') {
      app.setNavigationBarTitle({
        title: '选择收货地址'
      })
    } else if (from == 'takeout') {
      app.setNavigationBarTitle({
        title: '选择定位地址'
      })
    } else {
      app.setNavigationBarTitle({
        title: '搜索地址'
      })
    }
    this.subShopId = options.sub_shop_id || ''
    if (from == 'addAddress') {
      this.isInCountry(this.data.nationId)
    } else {
      this.getLocation()
    }
    this.getAddressList(from)
  }

  componentDidMount() {
    // var map = new qq.maps.Map(document.getElementById("search-address-map"), {
    //   // 地图的中心地理坐标。
    //   center: new qq.maps.LatLng(39.916527, 116.397128)
    // });
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      var that = this
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  isInCountry = (id, callBack) => {
    let that = this
    app.getLocation({
      success: res => {
        if (!res.latitude) {
          that.setData({
            localAddress: '定位失败'
          })
          return
        }
        app.sendRequest({
          url: '/index.php?r=map/IsInCountry',
          data: {
            nation_id: id,
            longitude: res.longitude,
            latitude: res.latitude
          },
          success: res => {
            if (res.data === true) {
              that.getLocation()
            } else {
              that.showMap = false
            }
          }
        })
      },
      fail: () => {
        // 模拟数据
        app.sendRequest({
          url: '/index.php?r=map/IsInCountry',
          data: {
            nation_id: id,
            longitude: 113.93041,
            latitude: 22.53332
          },
          success: res => {
            if (res.data === true) {
              that.getLocation()
            } else {
              that.showMap = false
            }
          }
        })
      }
    })
  }
  getAddressList = from => {
    let that = this
    let takeoutLocate = app.globalData.takeoutLocate
    let shopInfo = app.globalData.takeoutShopInfo
    let addressList = []
    let hasInDistance = true
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      success: res => {
        let address = res.data
        for (var i = 0, j = address.length - 1; i <= j; i++) {
          if (from == 'takeout') {
            address[i].is_distance =
              app.calculationDistanceByLatLng(
                shopInfo.latitude,
                shopInfo.longitude,
                address[i].latitude,
                address[i].longitude
              ) < shopInfo.deliver_distance
                ? 1
                : 0
          }
          if (address[i].latitude == 0) {
            hasInDistance = false
          }
          addressList.push(address[i])
        }
        that.setData({
          addressList: addressList,
          from: from,
          hasInDistance: hasInDistance
        })
      }
    })
  }
  selectAddress = e => {
    let pages = app.getCurrentPages(),
      prePage = pages[pages.length - 2],
      data = {},
      addressInfo = e.currentTarget.dataset.info
    app.globalData.takeoutAddressSelected = addressInfo
    data['eles[' + this.compindex + '].location_address'] =
      addressInfo.address_info.detailAddress
    prePage.setData(data)
    app.globalData.takeoutLocate.lat = addressInfo.latitude || ''
    app.globalData.takeoutLocate.lng = addressInfo.longitude || ''
    app.globalData.takeoutLocate.id = addressInfo.id || ''
    app.globalData.takeoutRefresh = true
    app.turnBack()
  }
  // showProDialog = () => {
  //   this.setData({
  //     selectProCityDirs: false,
  //     regionStr: this.oldRegionStr || ''
  //   })
  //   this.region = this.data.selectRegion
  //   this.regionid = this.data.selectRegionId
  //   this.oldRegionStr = this.data.regionStr
  // }
  changeRegion = e => {
    let regionStr = [];
    let selectRegion = [];
    let selectRegionId = e;

    e.reduce((p, c, i) => {
      for (let j = 0, l = p.length; j < l; j++) {
        if (p[j].value === c) {
          regionStr[i] = p[j].label;
          selectRegion[i] = j;
          return p[j].children || [];
        }
      }
    }, this.data.regionData);

    this.setData({
      regionStr,
      selectRegion,
      selectRegionId
    })
  }
  getArea = (id, callBack) => {
    // var nationId = this.data.nationId
    // app.sendRequest({
    //   url: '/index.php?r=Region/getRegionList',
    //   data: {
    //     country_region_id: nationId,
    //     pid: id
    //   },
    //   success: res => {
    //     res.data = res.data.reverse()
    //     callBack(res.data)
    //   }
    // })
    app.sendRequest({
      url: '/index.php?r=AppShop/getAllRegionInfo',
      data: {
        country_region_id: id || this.data.nationId
      },
      success: ({data}) => {
        callBack(data);
      }
    })
  }
  // 格式化地区
  formateRegionData = (data) => {
    if (!data) {
      return [];
    }
    return Object.keys(data).map(k => {
      let val = data[k];
      if (val.cities || val.towns) {
        return {
          label: val.name,
          value: val.id,
          children: this.formateRegionData(val.cities || val.towns)
        }
      }
      return {
        label: val.name,
        value: val.id
      }
    })
  }
  hideProCityDirs = () => {
    app.showLoading({
      title: '请稍等...'
    })
    setTimeout(() => {
      app.hideLoading()
      this.setData({
        selectRegionId: this.regionid,
        selectProCityDirs: true,
        regionStr: this.oldRegionStr || ''
      })
    }, 1000)
  }
  submitRegion = () => {
    app.showLoading({
      title: '请稍等...'
    })
    let that = this
    setTimeout(() => {
      app.hideLoading()
      that.setData({
        selectProCityDirs: true
      })
      that.oldRegionStr = that.data.regionStr
      if (that.data.searchInput) {
        let region = ''
        switch (that.data.regionStr[1]) {
          case '县':
          case '自治区直辖县级行政区划':
          case '省直辖县级行政区划':
            region = that.data.regionStr[0] + that.data.regionStr[2]
            break
          default:
            let regionAry = []
            that.data.regionStr.forEach(item => {
              if (regionAry.indexOf(item) < 0) {
                regionAry[regionAry.length] = item
              }
            })
            region = regionAry.join(' ')
            break
        }
        app.sendRequest({
          url: '/index.php?r=Map/suggestion&keyword=',
          data: {
            country_region_id: that.data.nationId,
            keyword: region + ' ' + that.data.searchInput,
            region: region
          },
          success: res => {
            that.setData({
              searchInput: that.data.searchInput,
              searchAddress: res.data
            })
          }
        })
      }
    }, 1000)
  }
  getLocation = () => {
    let that = this
    if (app.globalData.locationInfo.latitude) {
      let location = app.globalData.locationInfo
      let info = location.info
      let lacalAddresss = info.formatted_addresses
        ? info.formatted_addresses.recommend
        : info.address
      that.oldRegionStr = [
        info.ad_info.province,
        info.ad_info.city,
        info.ad_info.district
      ]
      that.setData({
        regionStr: info.formatted_addresses
          ? that.oldRegionStr
          : [info.address_component.nation, info.address_component.ad_level_3],
        localLatLng: info,
        localAddress: lacalAddresss,
        latitude: location.latitude,
        longitude: location.longitude,
        markers: [
          {
            latitude: location.latitude,
            longitude: location.longitude,
            iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/circle.png',
            width: 20,
            height: 20
          },
          {
            latitude: location.latitude,
            longitude: location.longitude,
            iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
            width: 20,
            height: 30
          }
        ]
      })
      that.locateAddress = lacalAddresss
      that.nearbyAddress({
        lat: location.latitude,
        lng: location.longitude,
        keyword: lacalAddresss
      })
    } else {
      app.getLocation({
        success: res => {
          if (!res.latitude) {
            that.setData({
              localAddress: '定位失败'
            })
            return
          }
          app.getAddressByLatLng(
            {
              lat: res.latitude,
              lng: res.longitude
            },
            data => {
              let lacalAddresss = data.data.formatted_addresses
                ? data.data.formatted_addresses.recommend
                : data.data.address
              that.oldRegionStr = [
                data.data.ad_info.province,
                data.data.ad_info.city,
                data.data.ad_info.district
              ]
              that.setData({
                regionStr: that.oldRegionStr,
                localLatLng: data.data,
                localAddress: lacalAddresss,
                latitude: res.latitude,
                longitude: res.longitude,
                markers: [
                  {
                    latitude: res.latitude,
                    longitude: res.longitude,
                    iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/circle.png',
                    width: 20,
                    height: 20
                  },
                  {
                    latitude: res.latitude,
                    longitude: res.longitude,
                    iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
                    width: 20,
                    height: 30
                  }
                ]
              })
              that.locateAddress = lacalAddresss
              that.nearbyAddress({
                lat: res.latitude,
                lng: res.longitude,
                keyword: that.locateAddress
              })
              app.setLocationInfo({
                latitude: res.latitude,
                longitude: res.longitude,
                address: data.data.formatted_addresses
                  ? data.data.formatted_addresses.recommend
                  : data.data.address,
                info: data.data
              })
            }
          )
        },
        fail: res => {
          // 模拟数据
          res = {
            latitude: 22.53332,
            longitude: 113.93041
          }
          app.getAddressByLatLng(
            {
              lat: 22.53332,
              lng: 113.93041
            },
            data => {
              let lacalAddresss = data.data.formatted_addresses
                ? data.data.formatted_addresses.recommend
                : data.data.address
              that.oldRegionStr = [
                data.data.ad_info.province,
                data.data.ad_info.city,
                data.data.ad_info.district
              ]
              that.setData({
                regionStr: that.oldRegionStr,
                localLatLng: data.data,
                localAddress: lacalAddresss,
                latitude: res.latitude,
                longitude: res.longitude,
                markers: [
                  {
                    latitude: res.latitude,
                    longitude: res.longitude,
                    iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/circle.png',
                    width: 20,
                    height: 20
                  },
                  {
                    latitude: res.latitude,
                    longitude: res.longitude,
                    iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
                    width: 20,
                    height: 30
                  }
                ]
              })
              that.locateAddress = lacalAddresss
              that.nearbyAddress({
                lat: res.latitude,
                lng: res.longitude,
                keyword: that.locateAddress
              })
              app.setLocationInfo({
                latitude: res.latitude,
                longitude: res.longitude,
                address: data.data.formatted_addresses
                  ? data.data.formatted_addresses.recommend
                  : data.data.address,
                info: data.data
              })
            }
          )
        }
      })
    }
  }
  searchAddress = e => {
    let that = this
    let searchInput = e.target.value
    this.searchFunc && clearTimeout(this.searchFunc)
    if (searchInput.trim() != '') {
      this.searchFunc = setTimeout(() => {
        if (
          that.data.regionStr === undefined ||
          (!that.data.regionStr[1] && !that.data.regionStr[2]) ||
          (that.data.regionStr[1] == '请选择' &&
            that.data.regionStr[2] == '请选择')
        ) {
          app.showModal({
            content: '请先选择地区，再输入地址',
            confirmText: '好的',
            confirmColor: '#3091F2'
          })
          return
        }
        let region = ''
        switch (that.data.regionStr[1]) {
          case '县':
          case '自治区直辖县级行政区划':
          case '省直辖县级行政区划':
            region = that.data.regionStr[0] + that.data.regionStr[2]
            break
          default:
            let regionAry = []
            that.data.regionStr.forEach(item => {
              if (regionAry.indexOf(item) < 0) {
                regionAry[regionAry.length] = item
              }
            })
            region = regionAry.join(' ')
            break
        }
        app.sendRequest({
          url: '/index.php?r=Map/suggestion&keyword=',
          data: {
            country_region_id: that.data.nationId,
            keyword: region + ' ' + searchInput,
            region: region
          },
          success: function(res) {
            that.setData({
              searchInput,
              searchAddress: res.data,
              showMap: false
            })
          }
        })
      }, 1000)
    } else {
      that.setData({
        searchAddress: [],
        showMap: true
      })
    }
  }
  relocate = e => {
    let that = this
    this.setData({
      localAddress: ''
    })
    app.getLocation({
      success: res => {
        app.getAddressByLatLng(
          {
            lat: res.latitude,
            lng: res.longitude
          },
          data => {
            let lacalAddresss = data.data.formatted_addresses
              ? data.data.formatted_addresses.recommend
              : data.data.address
            that.setData({
              localLatLng: data.data,
              localAddress: lacalAddresss
            })
            that.nearbyAddress({
              lat: res.latitude,
              lng: res.longitude,
              keyword: lacalAddresss
            })
            app.setLocationInfo({
              latitude: res.latitude,
              longitude: res.longitude,
              address: data.data.formatted_addresses
                ? data.data.formatted_addresses.recommend
                : data.data.address,
              info: data.data
            })
          }
        )
      }
    })
  }
  selectTakeoutRelocate = e => {
    let info = e.currentTarget.dataset.info
    app.globalData.takeoutLocate = {
      lat: info.latitude,
      lng: info.longitude
    }
    app.globalData.takeoutRefresh = true
    app.turnBack()
  }
  turnBackPageByLoacl = e => {
    app.globalData.takeoutAddressSelected = ''
    let pages = app.getCurrentPages();
    let prePage = pages[pages.length - 2];
    if (!prePage) {
      Toast.info('当前操作需要返回上一页');
      app.turnBack();
      return;
    }
      let data = {},
      addressDetail = JSON.parse(e.currentTarget.dataset.addressinfo)
    data[this.compid + '.location_address'] = addressDetail.formatted_addresses
      ? addressDetail.formatted_addresses.recommend
      : addressDetail.address
    prePage.setData(data)
    app.globalData.takeoutLocate.lat = addressDetail.location.lat
    app.globalData.takeoutLocate.lng = addressDetail.location.lng
    app.globalData.takeoutRefresh = true
    app.turnBack()
  }
  turnBackPage = e => {
    app.globalData.takeoutAddressSelected = ''
    let pages = app.getCurrentPages();
    let prePage = pages[pages.length - 2];
    if (!prePage) {
      Toast.info('当前操作需要返回上一页');
      app.turnBack();
      return;
    }
    let type = e.currentTarget.dataset.type;
    let addressDetail = JSON.parse(e.currentTarget.dataset.addressinfo);
    let regionId = this.data.selectRegionId
    if (this.data.from == 'addAddress' && type == 'search') {
      let { regionStr, nationId, nationname } = this.data
      let addressInfo = addressDetail
      let regionAry = [
        addressInfo.province || regionStr[0] || '',
        addressInfo.city || regionStr[1] || '',
        addressInfo.district || regionStr[2] || ''
      ]
      let joinStr = ''
      if (regionAry[1] === regionAry[2]) {
        regionAry[2] = ''
      }
      if (this.data.nationId != 1) {
        joinStr = ' '
      }
      prePage.setData({
        'address_info.country.id': nationId,
        'address_info.province.id': regionId[0],
        'address_info.city.id': regionId[1],
        'address_info.district.id': regionId[2],
        'address_info.country.text': nationname,
        'address_info.province.text': regionAry[0],
        'address_info.city.text': regionAry[1],
        'address_info.district.text': regionAry[2],
        'address_info.detailAddress': addressInfo.title || '',
        'address_info.regionInfoText': regionAry.join(joinStr) || '',
        'address_info.address': addressInfo.address,
        latitude: addressInfo.location.lat,
        longitude: addressInfo.location.lng
      })
    } else if (this.data.from == 'addAddress' && type == 'nearby') {
      var addressInfo = addressDetail.ad_info
      var regionAry = [
          addressInfo.province || '',
          addressInfo.city || '',
          addressInfo.district || ''
        ],
        joinStr = ''
      if (regionAry[1] === regionAry[2]) {
        regionAry[2] = ''
      }
      if (this.data.nationId != 1) {
        joinStr = ' '
      }
      prePage.setData({
        'address_info.country.id': this.data.nationId,
        'address_info.province.text': regionAry[0],
        'address_info.province.id': '',
        'address_info.city.text': regionAry[1],
        'address_info.city.id': '',
        'address_info.district.text': regionAry[2],
        'address_info.district.id': '',
        'address_info.detailAddress': addressDetail.title,
        'address_info.regionInfoText': regionAry.join(joinStr),
        'address_info.address': addressDetail.address,
        latitude: addressDetail.location.lat,
        longitude: addressDetail.location.lng
      })
    } else if (this.data.from == 'takeout') {
      let data = {}
      data[this.compid + '.location_address'] = addressDetail.title
      prePage.setData(data)
      app.globalData.takeoutLocate.lat = addressDetail.location.lat
      app.globalData.takeoutLocate.lng = addressDetail.location.lng
    } else if (this.data.from == 'franchisee' && this.compid) {
      let { location, address } = e.currentTarget.dataset.addressinfo
      let franchiseeCompid = this.compid
      prePage.setData({
        [franchiseeCompid + '.location_address']: address,
        [franchiseeCompid + '.param.latitude']: location.lat,
        [franchiseeCompid + '.param.longitude']: location.lng
      })
      app.globalData.locationInfo.address = address
      app.globalData.locationInfo.latitude = location.lat
      app.globalData.locationInfo.longitude = location.lng
      app.globalData.franchiseeListCompsRefresh = true
      if (Array.isArray(app.globalData.needRefreshFranchiseeListComps)) {
        if (
          ~franchiseeCompid.indexOf(
            app.globalData.needRefreshFranchiseeListComps
          )
        ) {
        } else {
          app.globalData.needRefreshFranchiseeListComps.push(franchiseeCompid)
        }
      } else {
        app.globalData.needRefreshFranchiseeListComps = [franchiseeCompid]
      }
    }
    app.globalData.takeoutRefresh = true
    // prePage.selectAddressBack = true // TODO: 暂时不用处理
    prePage.location = addressDetail.location
    app.turnBack()
  }
  nearbyAddress = option => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=Map/searchAreaInfo',
      data: {
        country_region_id: that.data.nationId,
        keyword: option.keyword,
        boundary: 'nearby(' + option.lat + ',' + option.lng + ',2000)'
      },
      success: res => {
        this.setData({
          nearbyAddress: res.data || [],
          showMap: true,
          show: true
        })
      }
    })
  }
  regionchange = e => {
    if (e.type == 'end' && (e.causedBy == 'scale' || e.causedBy == 'drag')) {
      clearTimeout(this.timer)
      let that = this
      let markers = this.data.markers
      this.mapCtx = this.mapRef.current
      this.mapCtx.getCenterLocation({
        type: 'gcj02',
        success: function(res) {
          markers[1] = {
            latitude: res.latitude,
            longitude: res.longitude,
            iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
            width: 20,
            height: 30
          }
          that.setData({
            latitude: res.latitude,
            longitude: res.longitude,
            circles: [
              {
                latitude: res.latitude,
                longitude: res.longitude,
                color: '#FF0000DD',
                fillColor: '#d1edff88',
                radius: 300, //定位点半径
                strokeWidth: 1
              }
            ],
            markers: markers
          })
          that.timer = setTimeout(() => {
            app.sendRequest({
              url: '/index.php?r=Map/getAreaInfoByLatAndLng',
              data: {
                latitude: res.latitude,
                longitude: res.longitude
              },
              success: result => {
                that.nearbyAddress({
                  keyword: result.data.formatted_addresses.recommend,
                  lat: res.latitude,
                  lng: res.longitude
                })
              }
            })
          }, 500)
        }
      })
    }
  }
  addNewAddress = () => {
    let pages = app.getCurrentPages(),
      prePage = pages[pages.length - 2]
    prePage.setData({
      'address_info.country.id': this.data.nationId,
      'address_info.province.text': this.data.regionStr[0],
      'address_info.city.text': this.data.regionStr[1],
      'address_info.district.text': this.data.regionStr[2],
      'address_info.regionInfoText':
        this.data.regionStr[0] +
        this.data.regionStr[1] +
        this.data.regionStr[2],
      detailAddress: '',
      'address_info.detailAddress': ''
    })
    app.turnBack()
  }
  reset = () => {
    let markers = this.data.markers
    let that = this
    markers[1].latitude = this.data.markers[0].latitude
    markers[1].longitude = this.data.markers[0].longitude
    this.setData({
      markers: markers,
      latitude: that.data.markers[0].latitude,
      longitude: that.data.markers[0].longitude
    })
    app.sendRequest({
      url: '/index.php?r=Map/getAreaInfoByLatAndLng',
      data: {
        latitude: that.data.markers[0].latitude,
        longitude: that.data.markers[0].longitude
      },
      success: result => {
        that.nearbyAddress({
          keyword: result.data.formatted_addresses.recommend,
          lat: that.data.markers[0].latitude,
          lng: that.data.markers[0].longitude
        })
      }
    })
  }

  render() {
    let {
      regionStr,
      localLatLng,
      localAddress,
      searchAddress,
      addressList,
      hasInDistance,
      from,
      showMap,
      longitude,
      latitude,
      markers,
      nationId,
      show,
      nearbyAddress,
      selectProCityDirs,
      selectRegion,
      province,
      regionData,
      regionCols,
      searchInput
    } = this.state

    // 去除无value的的值,无效数据
    // debugger: Each child in an array or iterator should have a unique "key" prop
    regionData.forEach((item, index) => {
      if (!item.value) {
        regionData.splice(index, 1);
      }
    })
    
    return (
      <div className="official-page search-address">
        <TopNav title="搜索地址"/>
        <div className="search-address">
          <span>
            <Picker
              data={regionData}
              value={['', '', '']}
              cols={regionCols}
              onOk={e => this.changeRegion(e)}
            >
              <div>
                <span className="address-text">
                  {regionStr[2] || regionStr[1] || '请选择'}
                </span>
                <span className="ico-moon icon-downarrow"></span>
              </div>
            </Picker>
          </span>
          <input
            type="text"
            placeholder="查找小区/学校/大厦等"
            vaule={searchInput}
            onInput={e => this.searchAddress(e)}
          />
        </div>
        <ScrollView scroll-y="true" style={convertLineStyleData('height: calc(100% - 84rpx);')}>
          <div
            className="myAddress-wrap page"
            id="myAddress"
            style={convertLineStyleData('height: 100%;')}
          >
            {from == 'takeout' && (
              <React.Fragment>
                <div className="address-list-title">当前地址</div>
                <div className="address-local">
              <span
                className="current-address"
                data-addressinfo={localLatLng}
                onClick={this.turnBackPageByLoacl}
              >
                {localAddress || '定位中...'}
              </span>
                  <span
                    className="ico-moon icon-relocate"
                    onClick={this.relocate}
                  >
                重新定位
              </span>
                </div>
                {searchAddress.length && (
                  <div>
                    <div className="address-list-title">搜索地址</div>
                    {searchAddress.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div
                            className={
                              'single-search-result ' +
                              (index == 0 ? 'first' : '')
                            }
                            data-addressinfo={JSON.stringify(item)}
                            data-type="search"
                            onClick={this.turnBackPage}
                          >
                            <div className="single-search-title">
                              {item.title}
                            </div>
                            <div className="single-search-detail">
                              {item.address}
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    })}
                  </div>
                )}
                <div className="address-list-title">收货地址</div>
                {!addressList.length ? (
                  <React.Fragment>
                    <div style={convertLineStyleData('color:#a8a8a8; padding:20px;')}>
                      暂无收货地址
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {addressList.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          {item.latitude != '' && (
                            <div className="myAddress-address">
                              <div
                                className="myAddress-address-top"
                                data-info={item}
                                onClick={this.selectAddress}
                                data-id={item.id}
                              >
                                <div>
                                  {item.address_info.label == 0 && (
                                    <label className="home address-label">
                                      家
                                    </label>
                                  )}
                                  {item.address_info.label == 2 && (
                                    <label className="company address-label">
                                      公司
                                    </label>
                                  )}
                                  {item.address_info.label == 1 && (
                                    <label className="school address-label">
                                      学校
                                    </label>
                                  )}
                                  <span className="address-detail">
                                {item.address_info.province.text +
                                item.address_info.city.text +
                                item.address_info.district.text +
                                item.address_info.detailAddress}
                              </span>
                                </div>
                                <span className="address-person">
                              {item.address_info.name +
                              ' ' +
                              (item.address_info.sex == 1
                                ? '(先生)'
                                : item.address_info.sex == 0
                                  ? '(女士)'
                                  : '') +
                              ' ' +
                              item.address_info.contact}
                            </span>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      )
                    })}
                    {!hasInDistance && (
                      <React.Fragment>
                        <div className="address-list-title">
                          以下地址信息不全（需重新编辑）
                        </div>
                        {addressList.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              {item.latitude == '' && (
                                <div
                                  className="myAddress-address"
                                  style={convertLineStyleData('background-color:#eee;')}
                                >
                                  <div
                                    className="myAddress-address-top"
                                    data-info={item}
                                    data-id={item.id}
                                  >
                                    <div>
                                      {item.address_info.label == 0 && (
                                        <label className="home address-label">
                                          家
                                        </label>
                                      )}
                                      {item.address_info.label == 2 && (
                                        <label className="company address-label">
                                          公司
                                        </label>
                                      )}
                                      {item.address_info.label == 1 && (
                                        <label className="school address-label">
                                          学校
                                        </label>
                                      )}
                                      <span className="address-detail">
                                    {item.address_info.province.text +
                                    item.address_info.city.text +
                                    item.address_info.district.text +
                                    item.address_info.detailAddress}
                                  </span>
                                    </div>
                                    <span className="address-person">
                                  {item.address_info.name +
                                  ' ' +
                                  (item.address_info.sex == 1
                                    ? '(先生)'
                                    : item.address_info.sex == 0
                                      ? '(女士)'
                                      : '') +
                                  ' ' +
                                  item.address_info.contact}
                                </span>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          )
                        })}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
            {!!searchAddress.length && from != 'takeout' && (
              <div>
                <div className="address-list-title">搜索地址</div>
                {searchAddress.map((item, index) => {
                  return (
                    <React.Fragment key={item.id}>
                      <div
                        className={
                          'single-search-result ' + (index == 0 ? 'first' : '')
                        }
                        data-addressinfo={JSON.stringify(item)}
                        data-type="search"
                        onClick={this.turnBackPage}
                      >
                        <div className="single-search-title">
                          {item.title}
                        </div>
                        <div className="single-search-detail">
                          {item.address}
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            )}
            {!searchAddress.length && !showMap && (
              <div>
                <div className="address-null">
                  <div className="address-null-img">
                    <img
                      src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-journey-null.png"
                      onClick={this.addNewAddress}
                    />
                  </div>
                  <div
                    className="address-null-title"
                    onClick={this.addNewAddress}
                  >
                    找不到地址？
                  </div>
                  <div
                    className="address-null-tips"
                    onClick={this.addNewAddress}
                  >
                    <span>请尝试只输入小区，写字楼或学校名</span>
                    <span>也可前往详情地址</span>
                    <span style={convertLineStyleData('color:#3091F2;')}>手动输入</span>~
                  </div>
                </div>
              </div>
            )}
            {showMap && (nationId === '' || nationId == 1) && show && (
              <div id="search-address-map">
                <Map
                  ref={this.mapRef}
                  id="map"
                  longitude={longitude}
                  latitude={latitude}
                  markers={markers}
                  style={convertLineStyleData("width:100%;height:394rpx;")}
                  bindregionchange={this.regionchange}
                >
                  <div className="controls" onClick={this.reset}>
                    <img src="http://test.zhichiwangluo.com/zhichi_frontend/static/webapp/images/takeout/reset.png" />
                  </div>
                </Map>
              </div>
            )}
            {!(nationId === '' || nationId == 1) && !regionStr && (
              <div className="no-nearby">请先选择地区</div>
            )}
            {(nationId === '' || nationId == 1) &&
            !!nearbyAddress.length &&
            (from == 'takeout' || from == 'addAddress') &&
            !searchAddress.length &&
            showMap && (
              <ScrollView
                className="myAddress-near-address"
                scroll-y="true"
                style={convertLineStyleData('height:calc(100% - 394rpx);')}
              >
                {!!nearbyAddress.length && (
                  <div className="address-list-title">附近地址</div>
                )}
                {nearbyAddress.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className={
                          'single-nearby-address ' +
                          (index == 0 ? 'first' : '')
                        }
                        data-addressinfo={JSON.stringify(item)}
                        data-type="nearby"
                        onClick={this.turnBackPage}
                      >
                        <div className="nearby-title">{item.title}</div>
                        <div className="nearby-address">{item.address}</div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </ScrollView>
            )}
            {(nationId === '' || nationId == 1) &&
            !nearbyAddress.length &&
            showMap &&
            show && (<div className="no-nearby">暂无附近地址</div>)}
          </div>
        </ScrollView>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/search-address/SearchAddress.jsx